import React from "react";
import { motion } from "framer-motion";
import partnerImage from "@/assets/partner-image.webp";
import partnerImageDesktop from "@/assets/partner-image-desktop.webp";

export function PartnerSection() {
  return (
    <section
      className="w-full relative overflow-hidden"
      aria-labelledby="partner-heading"
      style={{ background: "linear-gradient(to bottom, hsl(var(--sailcloth)), hsl(var(--horizon) / 0.4))" }}
    >
      <div className="flex max-lg:flex-col items-end">
        {/* Image - flush to left edge on desktop */}
        <motion.div
          className="w-1/2 max-lg:w-full flex max-lg:justify-center max-lg:order-first shrink-0"
          initial={{ opacity: 0, x: -40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7, ease: "easeOut" }}
        >
          {/* Desktop image - cropped version */}
          <img
            src={partnerImageDesktop}
            alt="Older adult using GrandPad tablet at desk with coffee"
            className="hidden lg:block h-[680px] w-auto object-contain object-left-bottom"
            width={1570}
            height={1360}
            loading="lazy"
            decoding="async"
          />
          {/* Mobile image - full version */}
          <img
            src={partnerImage}
            alt="Older adult using GrandPad tablet at desk with coffee"
            className="lg:hidden w-full max-w-[400px] h-auto object-contain object-center"
            width={1744}
            height={1314}
            loading="lazy"
            decoding="async"
          />
        </motion.div>

        {/* Content - constrained to right side */}
        <motion.div
          className="w-1/2 max-lg:w-full flex flex-col justify-center gap-4 pr-20 3xl:pr-28 4xl:pr-32 py-24 pl-8 max-lg:px-8 max-lg:py-16 max-sm:px-4 max-lg:text-center self-center max-w-[720px] 3xl:max-w-[800px] 4xl:max-w-[900px]"
          initial={{ opacity: 0, x: 40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7, ease: "easeOut", delay: 0.15 }}
        >
          <span className="text-caption text-beacon uppercase pl-[3px] max-lg:pl-0 block">A Partner of Trust</span>
          <h2 id="partner-heading" className="text-h2 text-foreground max-md:text-h3">
            Built for Healthcare. Trusted Across Care Settings.
          </h2>
          <p className="text-body-lg text-foreground">
            GrandPad is trusted by organizations that serve older adults across the continuum of care, including:
          </p>
          <ul className="flex flex-col gap-3 text-body text-foreground list-disc list-outside pl-5 max-lg:text-left max-lg:mx-auto">
            <li>Health plans (Medicare Advantage, Medicaid, DSNP, Special Needs Plans, PACE)</li>
            <li>State and local agencies</li>
            <li>Community-based health care providers</li>
          </ul>
        </motion.div>
      </div>
    </section>
  );
}
